import React from 'react'

export default function InlineError({ message = '문제가 발생했습니다', className = '' }) {
    return (
        <div className={`p-4 text-sm text-red-600 ${className}`}>{message}</div>
    )
}
